module.exports = __webpack_public_path__ + "img/5.802d4de9.png";